import React from 'react';
import './index.scss';

const InterpolateLink = ({ translation, firstLink, secondLink }) => {
  const firstSplitter = `%{${firstLink.name}}`;
  const secondSplitter = `%{${secondLink.name}}`;

  const [part1, rest] = translation.split(firstSplitter);
  const [part2, part3] = rest.split(secondSplitter);

  return (
    <>
      <span>{part1}</span>
      <a className="interpolated-link" href={firstLink.path} target="_blank" rel="noreferrer">
        {firstLink.translation}
      </a>
      <span>{part2}</span>
      <a className="interpolated-link" href={secondLink.path} target="_blank" rel="noreferrer">
        {secondLink.translation}
      </a>
      <span>{part3}</span>
    </>
  );
};

export default InterpolateLink;
